import React from 'react';

import { useI18n } from 'Hooks';

import { Wrapper } from './styles';

export interface Props {
  extraSpaceLeft?: boolean;
  disabled?: boolean;
  floating?: boolean;
  isLoading?: boolean;
  buttonText?: string;
  handleSubmit?: (e) => void;
  style?: React.CSSProperties;
}

const SubmitButton: React.FC<Props> = ({
  extraSpaceLeft = false,
  disabled = false,
  floating = false,
  isLoading = false,
  buttonText,
  handleSubmit,
  style,
}) => {
  const { t } = useI18n();

  let buttonWidth = '100%';
  let leftPos = '0';

  if (floating && extraSpaceLeft) {
    leftPos = '170px';
    buttonWidth = 'calc(100% - 203px)';
  } else if (floating) {
    leftPos = '32px';
    buttonWidth = 'calc(100% - 64px)';
  }

  return (
    <Wrapper
      disabled={disabled}
      onClick={handleSubmit}
      type="submit"
      floating={floating}
      buttonWidth={buttonWidth}
      leftPos={leftPos}
      style={style}
      tabIndex={0}>
      {isLoading ? `${t('General.Loading')}...` : buttonText ? buttonText : t('General.Save')}
    </Wrapper>
  );
};

export default SubmitButton;
